export default "__VITE_ASSET__CfD8Onho__"